import functionToObjectURL from './functionToObjectURL';

module.exports = function isModern () {
	if (typeof Worker != 'undefined' && (window.URL || window.webkitURL)) {
		try {
			var worker = new Worker(functionToObjectURL(function () {}));
			worker.terminate();
			return true;
		} catch (error) {}
	}

	return false;
};


// WEBPACK FOOTER //
// ./src/client/isModern.js